var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsStepper',_vm._b({attrs:{"value":_vm.step,"closable":""},on:{"update:value":function($event){_vm.step=$event},"close":_vm.comeBackToInvestors},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('div',{class:item.class},[_c(item.is,_vm._b({tag:"component"},'component',{
                    schemaDouble: _vm.schemaDouble,
                    formData: _vm.formData,
                    loading: _vm.loading || _vm.localLoading,
                    ...item
                },false))],1)]}}])},'EqsStepper',{ steps: _vm.steps, progress: _vm.progress },false))
}
var staticRenderFns = []

export { render, staticRenderFns }